module.exports = __webpack_public_path__ + "img/organik-logo-RGB-horizontal.8809bc05.svg";